/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_ProductPictureByIdsGet } from '../models/Model_ProductPictureByIdsGet';
import type { Model_ProductPictureGet } from '../models/Model_ProductPictureGet';
import type { Shared_PictureResolutions } from '../models/Shared_PictureResolutions';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductPictureService {
    /**
     * @param resolution
     * @param productId
     * @returns Model_ProductPictureGet Success
     * @throws ApiError
     */
    public static getApiV1ProductPictures(
        resolution?: ConvertDatesToStrings<Shared_PictureResolutions>,
        productId?: ConvertDatesToStrings<string>,
    ): CancelablePromise<Array<Model_ProductPictureGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/productPictures',
            query: {
                'resolution': resolution,
                'productId': productId,
            },
        });
    }
    /**
     * @param id
     * @param resolution
     * @returns Model_ProductPictureGet Success
     * @throws ApiError
     */
    public static getApiV1ProductPictures1(
        id: ConvertDatesToStrings<string>,
        resolution?: ConvertDatesToStrings<Shared_PictureResolutions>,
    ): CancelablePromise<Model_ProductPictureGet> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/productPictures/{id}',
            path: {
                'id': id,
            },
            query: {
                'resolution': resolution,
            },
        });
    }
    /**
     * @param requestBody
     * @param resolution
     * @returns Model_ProductPictureByIdsGet Success
     * @throws ApiError
     */
    public static postApiV1ProductPicturesMultiple(
        requestBody: ConvertDatesToStrings<Array<string>>,
        resolution?: ConvertDatesToStrings<Shared_PictureResolutions>,
    ): CancelablePromise<Array<Model_ProductPictureByIdsGet>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/productPictures/multiple',
            query: {
                'resolution': resolution,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
